// extracted by mini-css-extract-plugin
export default {"pill":"StatusPill_pill__Y+VCv","new":"StatusPill_new__TSWcB","run":"StatusPill_run__z4IiU","done":"StatusPill_done__YVDJv","compact":"StatusPill_compact__oOAPS"};